// Component names
export const NAME_BUTTON = 'BButton'
export const NAME_BUTTON_CLOSE = 'BButtonClose'
export const NAME_COL = 'BCol'
export const NAME_DROPDOWN = 'BDropdown'
export const NAME_DROPDOWN_DIVIDER = 'BDropdownDivider'
export const NAME_DROPDOWN_FORM = 'BDropdownForm'
export const NAME_DROPDOWN_GROUP = 'BDropdownGroup'
export const NAME_DROPDOWN_HEADER = 'BDropdownHeader'
export const NAME_DROPDOWN_ITEM = 'BDropdownItem'
export const NAME_DROPDOWN_ITEM_BUTTON = 'BDropdownItemButton'
export const NAME_DROPDOWN_TEXT = 'BDropdownText'
export const NAME_FORM = 'BForm'
export const NAME_FORM_CHECKBOX = 'BFormCheckbox'
export const NAME_FORM_CHECKBOX_GROUP = 'BFormCheckboxGroup'
export const NAME_FORM_GROUP = 'BFormGroup'
export const NAME_FORM_INVALID_FEEDBACK = 'BFormInvalidFeedback'
export const NAME_FORM_RADIO = 'BFormRadio'
export const NAME_FORM_RADIO_GROUP = 'BFormRadioGroup'
export const NAME_FORM_ROW = 'BFormRow'
export const NAME_FORM_SELECT = 'BFormSelect'
export const NAME_FORM_SELECT_OPTION = 'BFormSelectOption'
export const NAME_FORM_SELECT_OPTION_GROUP = 'BFormSelectOptionGroup'
export const NAME_FORM_TEXT = 'BFormText'
export const NAME_FORM_TEXTAREA = 'BFormTextarea'
export const NAME_FORM_VALID_FEEDBACK = 'BFormValidFeedback'
export const NAME_LINK = 'BLink'
export const NAME_MODAL = 'BModal'
export const NAME_POPOVER = 'BPopover'
export const NAME_TAB = 'BTab'
export const NAME_TABLE = 'BTable'
export const NAME_TABLE_CELL = 'BTableCell'
export const NAME_TABLE_LITE = 'BTableLite'
export const NAME_TABLE_SIMPLE = 'BTableSimple'
export const NAME_TABS = 'BTabs'
export const NAME_TBODY = 'BTbody'
export const NAME_TFOOT = 'BTfoot'
export const NAME_TH = 'BTh'
export const NAME_THEAD = 'BThead'
export const NAME_TOAST = 'BToast'
export const NAME_TOASTER = 'BToaster'
export const NAME_TOOLTIP = 'BTooltip'
export const NAME_TR = 'BTr'

// Helper component names
export const NAME_FORM_BUTTON_LABEL_CONTROL = 'BVFormBtnLabelControl'
export const NAME_FORM_RATING_STAR = 'BVFormRatingStar'
export const NAME_POPOVER_HELPER = 'BVPopover'
export const NAME_POPOVER_TEMPLATE = 'BVPopoverTemplate'
export const NAME_POPPER = 'BVPopper'
export const NAME_TAB_BUTTON_HELPER = 'BVTabButton'
export const NAME_TOAST_POP = 'BVToastPop'
export const NAME_TOOLTIP_HELPER = 'BVTooltip'
export const NAME_TOOLTIP_TEMPLATE = 'BVTooltipTemplate'
export const NAME_TRANSITION = 'BVTransition'
export const NAME_TRANSPORTER = 'BVTransporter'
export const NAME_TRANSPORTER_TARGET = 'BVTransporterTarget'
